module.exports = __webpack_public_path__ + "images/emoji/envelope.8607e3f99f81ba08489b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/envelope.png
// module id = rmy0
// module chunks = 1